export const MAX_TRADING_FLOW_COUNT = 120;
